import styled, { css } from 'styled-components';
import { BrandColor, ShadeColor } from '@lux/tokens';

export const Button = styled.button<{
    active: boolean;
}>`
    flex: 1 0 auto;
    margin: 10px 16px 7px;
    letter-spacing: 0.03em;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    border: none;
    background: none;
    padding: 0;

    span {
        transition: color 100ms ease-in-out;
    }

    span:hover {
        color: ${ShadeColor.dark60};
    }

    ${({ active }) =>
        active &&
        css`
            border-bottom: solid 2px ${BrandColor.primary};
            margin-top: 12px;
            opacity: initial;

            span:hover {
                color: initial;
            }
        `};

    &:first-of-type {
        margin-left: 0;
    }
`;
